import React from 'react'
import * as Styled from './ui-follow-us.styled'
import { useTranslation, withTranslation } from 'react-i18next'
import { FacebookIcon } from '../core/icons'

const UiFollowUs: React.FC = () => {
  const { t } = useTranslation()
  const socials = [
    {
      link: 'https://facebook.com/derzhzakupivli.online',
      alt: 'Facebook',
      src: <FacebookIcon />
    }
  ]

  return (
    <Styled.SocialsWrapper>
      {t('Слідкуйте за нами')}
      <Styled.SocialsList>
        {socials.map((item) => (
          <li key={item.alt}>
            <a href={item.link} target='_blank' rel="noopener noreferrer nofollow" aria-label={item.alt}>
              {item.src}
            </a>
          </li>
        ))}
      </Styled.SocialsList>
    </Styled.SocialsWrapper>
  )
}

export default withTranslation('dzo')(UiFollowUs)
